export default __webpack_public_path__ + "static/media/crmFilledIcon.141d2998.svg";